import { render } from "./ModalCode.vue?vue&type=template&id=39ae1aa6&scoped=true"
import script from "./ModalCode.vue?vue&type=script&lang=js"
export * from "./ModalCode.vue?vue&type=script&lang=js"

import "./ModalCode.vue?vue&type=style&index=0&id=39ae1aa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ae1aa6"]])

export default __exports__